"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

exports.__esModule = true;

var react_1 = __importDefault(require("react"));

exports.SVG = function () {
  return react_1["default"].createElement("svg", {
    viewBox: "0 0 20 20",
    fill: "none"
  }, react_1["default"].createElement("path", {
    d: "M6.60863 11.9998L13.3916 11.9998C13.9326 11.9998 14.2036 11.3948 13.8206 11.0398L10.4296 7.49776C10.1926 7.27776 9.80763 7.27776 9.57063 7.49776L6.17963 11.0398C5.79663 11.3948 6.06763 11.9998 6.60863 11.9998Z",
    fill: "#727B7F"
  }));
};